import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';

export const SC_SpanCounter =styled.span`
    position: absolute;
    bottom: ${theme.ZrSpacingHorizontalMicro};;
    left: ${theme.ZrSpacingHorizontalXxs};
    font-size: ${theme.ZrFontSizeNano};
    color: ${theme.ZrColorNeutralMedium03};
    -webkit-transform-origin: left top;
    -ms-transform-origin: left top;
    transform-origin: left top;
    white-space: nowrap;
    overflow: hidden;
    z-index: 1;
    pointer-events: none;
    -webkit-transition: all 0.2s ease 0s;
    transition: all 0.2s ease 0s;
`